import { Component, Output, EventEmitter } from '@angular/core';
export class OverlayComponent {
public onClick = new EventEmitter<void>();
constructor() { }
/**
 * @return {?}
 */
public click(): void {
    this.onClick.emit();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-overlay',
  template: `<div (click)="click()" class="overlay"></div>`,
  styles: [`:host .overlay{position:fixed;z-index:9998;background-color:rgba(0,0,0,.5);height:100%;width:100%;top:0;left:0}:host .overlay-blocking{pointer-events:none}`]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onClick': [{ type: Output },],
};
}

function OverlayComponent_tsickle_Closure_declarations() {
/** @type {?} */
OverlayComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OverlayComponent.ctorParameters;
/** @type {?} */
OverlayComponent.propDecorators;
/** @type {?} */
OverlayComponent.prototype.onClick;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
